import styled from "styled-components/macro";

export const TopRightCorner = styled.div`
	font-size: 1rem;
	display: flex;
	color: #3a5558;
	margin-left: auto;
`;
